/* Source: /home/sidsolaiyappan/skooch_ai/auth/landing_view_new.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { LandingHeroMount } from "./landing_hero.js";
function LandingViewNew(props) {
  const {callbacks} = props;
  return __jacJsx(LandingHeroMount, {"callbacks": callbacks}, []);
}
export {LandingViewNew};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:LandingViewNew": {"is_writer": false, "touches": ["*"]}}); };
//# sourceMappingURL=landing_view_new.js.map
